import { Link } from "react-router-dom";
import classnames from "classnames";

import { PublishedNavigationElementChildrenInner as PublishedNavigationChildElement } from "@/lib/api";

import styles from "./navigation.module.css";

interface NavigationChildProps {
  element: PublishedNavigationChildElement;
  active?: boolean;
}

export default function NavigationChild({ element, active }: NavigationChildProps) {
  return (
    <Link
      key={element.id}
      to={element.full_path ?? ""}
      className={classnames(styles.navigationChild, {
        [styles.navigationChildActive]: active,
      })}
      tabIndex={0}
    >
      {element.title}
    </Link>
  );
}
